import { createContext, useCallback, useContext, useEffect } from 'react';
import { trackBannerClick, trackBannerImpression } from '../services/trackingService';

/**
 * Steht eine Anzeige als Vorschau in der Verwaltung (`/admin/werbeplatz`), zählt sie weder
 * Einblendung noch Klick: sonst stünde jeder Blick der Redaktion auf die Schalter in den
 * Geschäftszahlen, als hätte ein Besucher die Anzeige gesehen.
 */
export const AdPreviewContext = createContext(false);

/** Meldet die Einblendung einmal, außer in der Vorschau. */
export function useBannerImpression(slot: string): void {
  const preview = useContext(AdPreviewContext);
  useEffect(() => {
    if (!preview) trackBannerImpression(slot, 'landing');
  }, [preview, slot]);
}

/** Die Klickmeldung einer Anzeige, in der Vorschau stumm. */
export function useBannerClick(slot: string): (placement: string) => void {
  const preview = useContext(AdPreviewContext);
  return useCallback((placement: string) => {
    if (!preview) trackBannerClick(slot, placement);
  }, [preview, slot]);
}
